import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo, orgSchema } from "@/components/Seo";
import { useSettings, track } from "@/lib/api";
import { MarketPanel } from "@/components/market/MarketPanel";
import { CourseFinder } from "@/components/CourseFinder";
import { SectionHeader } from "@/components/ui-hot";
import { TrustBar, ProgramsGrid, WhyHot, MarketLabSection, Methodology, CareerPaths, NismSection, MentorsSection, StoriesSection, EventsSection, HubSection, FaqSection, CounsellingCTA, LocationSection } from "@/components/home/Sections";

const Hero = () => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0 grid-bg" />
    <div className="absolute -top-40 right-0 h-[500px] w-[500px] rounded-full bg-[#1E3A8A]/30 blur-[120px]" />
    <div className="container-x relative grid lg:grid-cols-12 gap-10 items-center py-16 sm:py-24 lg:py-28">
      <div className="lg:col-span-7">
        <p className="eyebrow mb-5 rise">Financial markets education & trading skills academy · Mohali</p>
        <h1 data-testid="hero-title" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-slate-50 rise rise-1">Master the Markets.<br /><span className="text-[var(--cyan)]">Build a Real Trading Skill.</span></h1>
        <p className="lead mt-6 max-w-xl rise rise-2">Practical education in Stock Markets, F&O, Technical Analysis and NISM exam preparation — built for beginners, aspiring traders and finance professionals.</p>
        <div className="mt-8 flex flex-wrap gap-3 rise rise-3">
          <Link to="/programs" data-testid="hero-explore-btn" className="btn btn-primary" onClick={() => track("cta_click", { cta: "hero_explore" })}>Explore Programs <ArrowRight size={16} /></Link>
          <Link to="/book-counselling" data-testid="hero-counselling-btn" className="btn btn-outline" onClick={() => track("cta_click", { cta: "hero_counselling" })}>Book a Free Counselling Session</Link>
        </div>
        <p data-testid="hero-trust-badge" className="mt-6 font-mono text-xs text-slate-400 rise rise-4">Offline + Online Learning &nbsp;|&nbsp; Live Market Sessions &nbsp;|&nbsp; Mentor-Led Training</p>
      </div>
      <div className="lg:col-span-5 rise rise-2"><MarketPanel /></div>
    </div>
  </section>
);

export default function Home() {
  const { data: s } = useSettings();
  return (
    <>
      <Seo title="The House of Trading | Stock Market & Trading Academy in Mohali" description="Financial markets education academy in Mohali & Chandigarh: stock market, F&O, technical analysis and NISM exam preparation programs. Offline + online, mentor-led, live market sessions." schema={orgSchema(s)} />
      <Hero />
      <TrustBar />
      <section className="section" id="learning-path">
        <div className="container-x grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4"><SectionHeader eyebrow="Find your learning path" title="Which program is right for me?" lead="Answer four quick questions and we'll point you to the programs that match your level, interest and goal." /><Link to="/learning-paths" data-testid="finder-full-link" className="text-sm font-semibold text-[var(--blue)]">Open full Learning Paths page →</Link></div>
          <div className="lg:col-span-8"><CourseFinder primary /></div>
        </div>
      </section>
      <ProgramsGrid />
      <WhyHot />
      <MarketLabSection />
      <Methodology />
      <CareerPaths />
      <NismSection />
      <MentorsSection />
      <StoriesSection />
      <EventsSection />
      <HubSection />
      <FaqSection />
      <CounsellingCTA />
      <LocationSection />
    </>
  );
}
